import { post } from './api';

const endpoints = {
  registerToSell: `${window.envConfig.MURRAY_API_BASE_URL}Seller/Register`,
};

export type RegisterToSellRequestType = {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  tellUsMore: string;
  state: string;
  category: string;
  businessType: string;
};

export type RegisterToSellReturnType = boolean;

export const submitRegisterToSell = async (
  request: RegisterToSellRequestType
): Promise<RegisterToSellReturnType> => {
  const results = await post<RegisterToSellReturnType>({
    url: endpoints.registerToSell,
    body: request as any,
  });
  return results;
};
